import { AccountInfo } from '@azure/msal-browser';
import { AzureUser } from '@app-models/azure-user';

import { CACHE_TTL_IN_MS } from '@app/auth-config';
import { GlobalConstants } from '@app-utils/global-constants';


const CURRENT_USER_KEY = "sowrf.currentUser";
const FILTER_KEY = "sowrf.filter";
const PREVIOUS_VIEW = "sowrf.previousView";

const SCREEN_MODE = "sowrf.screenMode";


//NOTE: this originlly used sessionStorage.. change back after debugging?
// Groups are only put in storage on overflow.
// see comment in MSAL where localstorage can be used across tabs.

type GroupMembershipEntry = {
    groups: string[],
    lastAccessed: number,
    expiresOn: number,
    sourceTokenId: string,
};

/**
 * Stores the groups in session storage for the given account
 * @param {AccountInfo} account 
 * @param {Array} groups 
 */
export const setGroupsInStorage = (account: AccountInfo, groups: string[]): void => {
    if (!account.idTokenClaims) return;

    const newEntry: GroupMembershipEntry = {
        groups: groups,
        lastAccessed: Date.now(),
        expiresOn: Date.now() + CACHE_TTL_IN_MS,
        sourceTokenId: account.idTokenClaims['uti'] as string,
    };

    localStorage.setItem(`gmc.${account.idTokenClaims.aud}.${account.idTokenClaims.oid}`, JSON.stringify(newEntry));
};





/**
 * Checks if the groups are in session storage and if their associated ID token is not expired
 * @param {AccountInfo} account 
 * @returns 
 */
export const checkGroupsInStorage = (account: AccountInfo): boolean => {
    if (!account.idTokenClaims) return false;

    const storageEntry = localStorage.getItem(`gmc.${account.idTokenClaims.aud}.${account.idTokenClaims.oid}`);
    
    if (!storageEntry) return false;

    const parsedStorageEntry = JSON.parse(storageEntry);
    return parsedStorageEntry.groups && parsedStorageEntry.expiresOn >= Date.now() && parsedStorageEntry.sourceTokenId === account.idTokenClaims['uti'];
};

/**
 * Returns the groups array from session storage
 * @param {AccountInfo} account 
 * @returns 
 */
export const getGroupsFromStorage = (account: AccountInfo): string[] | null => {
    if (!account.idTokenClaims) return null;

    const storageEntry = localStorage.getItem(`gmc.${account.idTokenClaims.aud}.${account.idTokenClaims.oid}`);
    
    if (!storageEntry) return null;

    return (JSON.parse(storageEntry) as GroupMembershipEntry).groups;
};

/**
 * This method clears session storage of group membership claims for the given account.
 * @param {AccountInfo} account
 */
export const clearGroupsInStorage = (account: AccountInfo): void => {
    if (!account.idTokenClaims) return;

    for (const key in sessionStorage) {
        if (key.startsWith(`gmc.${account.idTokenClaims.aud}.${account.idTokenClaims.oid}`)) {
            localStorage.removeItem(key);
        }
    }
};

export const setCurrentUserInStorage = (azureUser: AzureUser): void => {
    localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(azureUser));
};

export const getCurrentUserFromStorage = (): AzureUser => {
    const user = localStorage.getItem(CURRENT_USER_KEY);
    if (user != null) {
        return JSON.parse(user);
    } else {
        return GlobalConstants.noLoggedInUser;
    }
};


export const removeCurrentUserFromStorage = ():  void => {
    localStorage.removeItem(CURRENT_USER_KEY);
};


/*
export const setCurrentUserManagerInStorage = (azureUser: AzureUser): void => {
    localStorage.setItem(CURRENT_USER_MANAGER_KEY, JSON.stringify(azureUser));
};

export const getCurrentUserManagerFromStorage = (): AzureUser => {
    var user = localStorage.getItem(CURRENT_USER_MANAGER_KEY);
    if (user) {
        return JSON.parse(user);
    } else {
        return GlobalConstants.noLoggedInUser;
    }
};
export const removeCurrentUserManagerFromStorage = (): void => {
    localStorage.removeItem(CURRENT_USER_MANAGER_KEY);
};
*/

export const setFilterInStorage = (filter: string, value: string): void => {
    if (value == null) {
        sessionStorage.removeItem(FILTER_KEY + "." + filter);
    } else {
        sessionStorage.setItem(FILTER_KEY + "." + filter, value);
    }
};

//Return null, so we know if the proerty existed or not
export const getFilterFromStorage = (filter: string) => {
    const x = sessionStorage.getItem(FILTER_KEY + "." + filter);
    if (x) {
        if (!isNaN(Number(x))) {
            return Number(x);
        } else if (x === "true") {
            return true;
        } else if (x === "false") {
            return false;
        } else {
            return x;
        }

    } else {
        return null;
    }
};



export const setPreviousViewInStorage = (val: string): void => {
    sessionStorage.setItem(PREVIOUS_VIEW, val);
};
export const getPreviousViewFromStorage = (): string => {
    const x = sessionStorage.getItem(PREVIOUS_VIEW);
    if (x) {
        return x;
    } else {
        return "";
    }
};

export const setScreenModeInStorage = (val: string): void => {
    sessionStorage.setItem(SCREEN_MODE, val);
};
export const getScreenModeFromStorage = (): string => {
    const x = sessionStorage.getItem(SCREEN_MODE);
    if (x) {
        return x;
    } else {
        return "";//GlobalConstants.REQUEST_FORM_MODE_USER;
    }
};

